(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$stickyStateProvider', '$urlRouterProvider'];

    function stateConfig($stateProvider, $stickyStateProvider, $urlRouterProvider ) {
        $stateProvider
        .state('activity-history', {
            // parent: 'entity',
            parent: 'app',
            url: '/activity-history?page&sort&search',
            sticky: true,
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ccsTrApp.activityHistory.home.title',
                title: 'Activity Histories'
            },
            views: {
                // 'content@': {
                'activity-history@': {
                    templateUrl: 'app/entities/activity-history/activity-histories.html',
                    controller: 'ActivityHistoryController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activityHistory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('activity-history-detail', {
            // parent: 'entity',
            parent: 'app',
            url: '/activity-history/{id}',
            sticky: true,
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'ccsTrApp.activityHistory.detail.title',
                title: 'Detail'
            },
            views: {
                // 'content@': {
                'activity-history-detail@': {
                    templateUrl: 'app/entities/activity-history/activity-history-detail.html',
                    controller: 'ActivityHistoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activityHistory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ActivityHistory', function($stateParams, ActivityHistory) {
                    return ActivityHistory.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'activity-history',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('activity-history-detail.edit', {
            // parent: 'activity-history-detail',
            parent: 'app',
            // url: '/detail/edit',
            url: '/activity-history/detail/edit',
            sticky: false,
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/activity-history/activity-history-dialog.html',
                    controller: 'ActivityHistoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ActivityHistory', function(ActivityHistory) {
                            return ActivityHistory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('activity-history.new', {
            // parent: 'activity-history',
            parent: 'app',
            // url: '/new',
            url: '/activity-history/new',
            sticky: false,
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/activity-history/activity-history-dialog.html',
                    controller: 'ActivityHistoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                actDate: null,
                                actUser: null,
                                actDesc: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('activity-history', null, { reload: true });
                }, function() {
                    $state.go('activity-history');
                });
            }]
        })
        .state('activity-history.edit', {
            // parent: 'activity-history',
            parent: 'app',
            // url: '/{id}/edit',
            url: '/activity-history/{id}/edit',
            sticky: false,
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/activity-history/activity-history-dialog.html',
                    controller: 'ActivityHistoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ActivityHistory', function(ActivityHistory) {
                            return ActivityHistory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('activity-history', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('activity-history.delete', {
            // parent: 'activity-history',
            parent: 'app',
            // url: '/{id}/delete',
            url: '/activity-history/{id}/delete',
            sticky: false,
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/activity-history/activity-history-delete-dialog.html',
                    controller: 'ActivityHistoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ActivityHistory', function(ActivityHistory) {
                            return ActivityHistory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('activity-history', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });

        $stickyStateProvider.enableDebug( true );

    }

})();
